import * as React from "react";
import {Route} from "react-router-dom";

import AsyncRouteHandler from "./async-route-handler.tsx";
import type {CommonRouteProps} from "./types.ts";

export default class TopLevelRoute extends React.Component<CommonRouteProps> {
    render(): React.ReactNode {
        const {exact, path, component, template} = this.props;
        return (
            <Route
                exact={exact}
                path={path}
                render={() => (
                    <AsyncRouteHandler
                        component={component}
                        template={template}
                    />
                )}
            />
        );
    }
}
